import { StaticImageData } from "next/legacy/image";
import couchImage from "../../assets/image/Roadmap/couch.png";
import cx from "classnames";
import { CutoutAsset } from "../CutoutAsset/CutoutAsset";

type GiantPillProps = {
  videoSrc?: string;
  image?: StaticImageData;
  children: React.ReactElement;
  className?: string;
  hideAssetOnMobile?: boolean;
};
export const GiantPill: React.FC<GiantPillProps> = ({
  children,
  videoSrc = "/pillVideo.mp4",
  className,
  hideAssetOnMobile,
  image
}) => {
  const pillClassNames = cx(
    "flex flex-col tab:flex-row bg-coinage-white mx-auto rounded-[12px] tab:rounded-[200px] border-2 border-coinage-purple overflow-hidden gap-2 min-w-[300px] tab:min-w-[800px] max-w-[360px] tab:max-w-full w-full",
    className
  );

  const assetWrapperClassName = cx(
    "pill-image ml-0 w-full tab:w-[30%] tab:max-w-[300px] h-[150px] tab:h-[revert]",
    { "hidden tab:block": hideAssetOnMobile }
  );
  return (
    <div className={`${pillClassNames} safari-overflow`}>
      <div className={assetWrapperClassName}>
        <CutoutAsset image={image} videoSrc={videoSrc} color="white" />
      </div>
      <div className="flex flex-col justify-center px-5 py-4 tab:py-8 tab:pr-12 w-full lrg:w-1/2">
        {children}
      </div>
    </div>
  );
};
